module.exports = __webpack_public_path__ + "img/analysis.6cdfd51e.svg";